// extracted by mini-css-extract-plugin
export default {"root":"DialogPageFooter_root__eNQk-"};